import { render, staticRenderFns } from "./IconGevel.vue?vue&type=template&id=531c74b0"
import script from "./IconGevel.vue?vue&type=script&lang=ts"
export * from "./IconGevel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports